import { render } from "./individual-modification-form.vue?vue&type=template&id=3d985dda"
import script from "./individual-modification-form.vue?vue&type=script&lang=js"
export * from "./individual-modification-form.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__